export default __webpack_public_path__ + "static/media/ppt.56ab6b75.svg";